import React, { useContext, useEffect, useState } from "react";
import UniversalMenuHeader from "../../../components/UniversalMenuHeader/index.jsx";
import UniversalFooter from "../../../components/UniversalFooter/index.jsx";
import UniversalTarjetaCurso from "../../../components/UniversalTarjetaCurso/index.jsx";
import SubTarjetaCategoria from "./components/SubTarjetaCategoria/index.jsx";
import UniversalBarraBusqueda from "../../../components/UniversalBarraBusqueda/index.jsx";
import UniversalParticulas from "../../../components/UniversalParticulas/UniversalParticulas.jsx";
import {
  getCategoriaData,
  getCursosPopulares,
} from "./services/homeService.jsx";
import UModalLogin from "../../../components/UModalLogin/UModalLogin.jsx";
import UModalContactanos from "../../../components/UModalContactanos/UModalContactanos.jsx";
import UModalEnviarCorreo from "../../../components/UModalEnviarCorreo/UModalEnviarCorreo.jsx";
import UModalRecetContraseña from "../../../components/UModalRecetContraseña/UModalRecetContraseña.jsx";

import UModalCambiarContraseñaTemporal from "../../../components/UModalCambiarContraseñaTemporal/UModalCambiarContraseñaTemporal.jsx";
import { WindowSizeContext } from "../../../context/WindowSizeContext.jsx";
import { useSearchParams } from "react-router-dom";
import ContenedorCarrusel from "../../../components/ContenedorCarrusel/ContenedorCarrusel.jsx";
import { useNavigate } from "react-router-dom";

export default function Home() {
  const { width } = useContext(WindowSizeContext);
  let [searchParams] = useSearchParams();
  const [vCategorias, setVCategorias] = useState([]);
  const [vCursosPopulares, setVCursosPopulares] = useState([]);

  const [vIsModal, setVIsModal] = useState(false);
  const [vIsLogin, setVIsLogin] = useState(false);
  const [vIsEnviarCorreo, setEnviarCorreo] = useState(false);
  const [vIsCambioContraseñaTemporal, setCambioContraseñaTemporal] =
    useState(false);
  const [vIsRecetContraseña, setRecetContraseña] = useState(false);
  const [vIsContactanos, setVIsContactanos] = useState(false);

  const navigate = useNavigate();

  const irACursos = () => {
    navigate("/cursos");
  };

  
  

  useEffect(() => {
    if (searchParams.get("_tk")) {
      //localStorage.clear()
      localStorage.setItem("token", searchParams.get("_tk"));
      if (searchParams.get("_m") && searchParams.get("_m") == "reset") {
        mActivar_DesactivarModal("recetContraseña", true);
      } else {
        mActivar_DesactivarModal("cambiarContraseñaTemporal", true);
      }
    } else {
      mActivar_DesactivarModal();
    }
  }, [searchParams]);

  const mActivar_DesactivarModal = (vModalActivar, vIsActivo) => {
    const mResetearModals = () => {
      setEnviarCorreo(false);
      setCambioContraseñaTemporal(false);
      setRecetContraseña(false);
      setVIsLogin(false);
      setVIsContactanos(false);
    };
    setVIsModal(vIsActivo);
    if (!vIsActivo) {
      mResetearModals();
    } else {
      switch (vModalActivar) {
        case "enviarCorreo":
          mResetearModals();
          setEnviarCorreo(true);
          break;
        case "cambiarContraseñaTemporal":
          mResetearModals();
          setCambioContraseñaTemporal(true);
          break;
        case "recetContraseña":
          mResetearModals();
          setRecetContraseña(true);
          break;
        case "contactanos":
          mResetearModals();
          setVIsContactanos(true);

          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;
        case "login":
          mResetearModals();
          setVIsLogin(true);
          break;

        default:
          mResetearModals();
          break;
      }
    }
  };

  const mGetCategoriasFetch = () => {
    getCategoriaData()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "CATEGORIAS_OBTENIDAS":
              setVCategorias(result["detail"]["datos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };

  const mGetCursosPopularesFetch = () => {
    getCursosPopulares()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener cursos");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "MOSTRAR_CURSOS":
              setVCursosPopulares(result["detail"]["datos"]["cursos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };

  /*Effect*/
  useEffect(() => {
    mGetCategoriasFetch();
    mGetCursosPopularesFetch();
  }, []);
  
  useEffect(() => {
    console.log(localStorage.getItem("login"))
    console.log(localStorage.getItem("login")!== null)
    if (localStorage.getItem("login")!== null) {
      mActivar_DesactivarModal("login", true);
    }
  }, [])

  return (
    <div class="home-desktop-2">
      <UniversalParticulas
        data-figma-id="113:9518"
        key={"header-home"}
        className="home-header"
        vIsModal={vIsModal}
      >
        <UniversalMenuHeader
          mActivar_DesactivarModal={mActivar_DesactivarModal}
          nombrePaginaSeleccionada="Home"
        />

        {(!vIsModal || (width > 1439 && vIsModal)) && (
          <div data-figma-id="113:8869" class="home-bienvenida">
            <div data-figma-id="113:8870" class="home-bienvenida-eslogan">
              <p
                data-figma-id="113:8871"
                class="home-bienvenida-eslogan-texto-1"
              >
                Mejora tu carrera
              </p>
              <p
                data-figma-id="113:8872"
                class="home-bienvenida-eslogan-texto-2"
              >
                Aprende en línea , alineado a tu vida profesional de una manera
                flexible y cómoda
              </p>
            </div>
            <div data-figma-id="113:8873" class="home-botones">
              <div data-figma-id="113:9498" class="boton-ver-cursos">
                <p
                  data-figma-id="113:9499"
                  class="boton-ver-cursos-texto"
                  onClick={irACursos}
                >
                  Ver cursos
                </p>
              </div>
              <div
                data-figma-id="113:9500"
                class="boton-contactanos"
                onClick={() => mActivar_DesactivarModal("contactanos", true)}
              >
                <p data-figma-id="113:9501" class="boton-contactanos-texto">
                  Contáctanos
                </p>
              </div>
            </div>
            <div data-figma-id="113:8876" class="home-bienvenida-certificate">
              <img
                src="images/credencial-de-grado-1.svg"
                data-figma-id="113:9502"
                class="img-68"
              />
              <div
                data-figma-id="113:8878"
                class="home-bienvenida-certificate-textos"
              >
                <p
                  data-figma-id="113:8879"
                  class="home-bienvenida-certificate-texto-1"
                >
                  Certifícate
                </p>
                <p
                  data-figma-id="113:8880"
                  class="home-bienvenida-certificate-texto-2"
                >
                  Todos nuestros cursos incluyen certificados oficiales
                </p>
              </div>
            </div>
            {(!vIsModal || (width > 1439 && vIsModal)) && (
              <div data-figma-id="113:8881" class="home-barra-busqueda">
                <UniversalBarraBusqueda vCategoriasObtenidas={vCategorias} />
              </div>
            )}
          </div>
        )}

        <UModalLogin
          vIsLogin={vIsLogin}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalEnviarCorreo
          vIsEnviarCorreo={vIsEnviarCorreo}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        <UModalContactanos
          vIsContactanos={vIsContactanos}
          mActivar_DesactivarModal={mActivar_DesactivarModal}
        />
        {vIsCambioContraseñaTemporal && (
          <UModalCambiarContraseñaTemporal
            vIsCambioContraseñaTemporal={vIsCambioContraseñaTemporal}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}

        {vIsRecetContraseña && (
          <UModalRecetContraseña
            vIsRecetContraseña={vIsRecetContraseña}
            mActivar_DesactivarModal={mActivar_DesactivarModal}
          />
        )}
      </UniversalParticulas>

      {(!vIsModal || (width > 1439 && vIsModal)) && (
        <>
          <div data-figma-id="121:8940" class="home-cursos-explora">
            <div data-figma-id="113:8899" class="home-cursos-explora-titulo">
              <img
                src="images/category-1.svg"
                data-figma-id="121:8934"
                class="img-67"
              />
              <p
                data-figma-id="113:8901"
                class="home-cursos-explora-titulo-texto"
              >
                Explora cursos por categoría
              </p>
            </div>

            {/* ------ Inicio carrusel para las tarjetas de categorias -------*/}
            <ContenedorCarrusel>
              {vCategorias.map((vCartegoria) => {
                return (
                  <SubTarjetaCategoria
                    nombreCategoria={vCartegoria.nombre}
                    vCategoriasId={vCartegoria.id}
                  />
                );
              })}
            </ContenedorCarrusel>

            {/*  ------- Fin carrusel para las tarjetas de categorias -------*/}
          </div>

          <div data-figma-id="115:9278" class="home-cursos-populares">
            <div data-figma-id="113:8884" class="home-cursos-populares-titulo">
              <img
                src="images/Property-1Default.svg"
                data-figma-id="115:9240"
                class="img-66"
              />
              <p
                data-figma-id="113:8886"
                class="home-cursos-populares-titulo-texto"
              >
                Cursos Populares
              </p>
            </div>
            <div data-figma-id="113:8887" class="home-cursos-populares-filtro">
              <div
                data-figma-id="115:9242"
                class="filtro-todos-los-cursos"
                onClick={irACursos}
              >
                <p data-figma-id="115:9243" class="todos-los-cursos">
                  Todos los cursos
                </p>
              </div>
            </div>

            <div data-figma-id="113:8889" class="cursos">
              {/* Aquí se coloca el componente UniversalTarjetaCurso */}
              {vCursosPopulares.map((vCurso) => {
                return (
                  <UniversalTarjetaCurso
                    vIdCurso={vCurso.id}
                    categorias={vCurso.categorias}
                    nombreCurso={vCurso.nombre}
                    numTotalLecciones={vCurso.total_lecciones}
                    numTotalHoras={vCurso.duracion}
                    precioCurso={vCurso.precio}
                  />
                );
              })}
            </div>
          </div>
          <UniversalFooter />
        </>
      )}
    </div>
  );
}
